import { createReducer, on } from '@ngrx/store';
import * as LogsActions from './logs.actions';
import { LogEntry } from '../../shared/services/admin/logs.service';

export interface LogsState {
  logs: LogEntry[];
  total: number;
  page: number;
  page_size: number;
  loading: boolean;
  error: any;
  lastFilter: {
    level?: string;
    source?: string;
    module?: string;
    logger_name?: string;
    page?: number;
    page_size?: number;
    limit?: number;
    offset?: number;
  } | null;
}

export const initialState: LogsState = {
  logs: [],
  total: 0,
  page: 1,
  page_size: 50,
  loading: false,
  error: null,
  lastFilter: null,
};

export const reducer = createReducer(
  initialState,
  on(
    LogsActions.loadLogs,
    (state, { level, source, module, logger_name, page, page_size, limit, offset }) => ({
      ...state,
      loading: true,
      error: null,
      lastFilter: { level, source, module, logger_name, page, page_size, limit, offset },
    }),
  ),
  on(LogsActions.loadLogsSuccess, (state, { response }) => ({
    ...state,
    logs: response.logs,
    total: response.total,
    page: response.page,
    page_size: response.page_size,
    loading: false,
    error: null,
  })),
  on(LogsActions.loadLogsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(LogsActions.clearLogs, (state) => ({
    ...state,
    logs: [],
    total: 0,
    page: 1,
    page_size: 50,
    lastFilter: null,
  })),
);
